/** Flush bot: the Teen Patti strategy, which already reads the ranking from the table's config. */
import type { BotEngine } from '../../bots/types.js';
import { teenPattiBot } from '../teenpatti/bot.js';
import type { FlushAction, FlushLegal, FlushView } from './engine.js';

export const flushBot: BotEngine<FlushView, FlushLegal, FlushAction> = teenPattiBot as unknown as BotEngine<FlushView, FlushLegal, FlushAction>;
